<soft-page>
  <soft-dashboard class="mt-2"></soft-dashboard>
</soft-page>
